import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function AWSCloudFormationIcon(props: ACIconProps) {
  return <ACIconWrapper component={IconSvg} {...props} />;
}

const IconSvg = () => {
  return (
    <svg height="1em" viewBox="0 0 24 24" fill="none">
      <g clipPath="url(#clip0_10640_68220)">
        <path d="M24 0H0V24H24V0Z" fill="url(#paint0_linear_10640_68220)" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.9001 11.9888H17.4001V11.3878H15.9001V11.9888ZM8.4001 15.5943H9.9001V14.9934H8.4001V15.5943ZM5.4001 15.5943H7.5001V14.9934H5.4001V15.5943ZM5.4001 13.7915H9.0001V13.1906H5.4001V13.7915ZM5.4001 10.186H8.1001V9.58509H5.4001V10.186ZM5.4001 11.9888H15.3001V11.3878H5.4001V11.9888ZM11.1001 18.5989H4.2001V8.38325H11.1001V10.7869H11.7001V8.08279C11.7001 7.91693 11.5657 7.78233 11.4001 7.78233H3.9001C3.7342 7.78233 3.6001 7.91693 3.6001 8.08279V18.8993C3.6001 19.0652 3.7342 19.1998 3.9001 19.1998H11.4001C11.5657 19.1998 11.7001 19.0652 11.7001 18.8993V12.8901H11.1001V18.5989ZM20.4001 11.0874C20.4001 13.029 18.652 13.7044 17.7277 13.7903L12.9001 13.7915V13.1906H17.7001C17.7586 13.1837 19.8001 12.9635 19.8001 11.0874C19.8001 9.37897 18.259 9.03224 17.9503 8.97996C17.7964 8.95382 17.6881 8.81441 17.7013 8.65877C17.7016 8.65306 17.7022 8.64765 17.7028 8.64224C17.6863 7.67686 17.0944 7.3752 16.8379 7.28987C16.3591 7.13063 15.8254 7.28296 15.5431 7.66154C15.4774 7.75048 15.3688 7.79585 15.2584 7.77902C15.1492 7.7625 15.0577 7.68738 15.0205 7.58282C14.8342 7.06062 14.5639 6.7223 14.188 6.34583C13.2478 5.4114 11.9716 5.1533 10.7776 5.65567C10.1512 5.91978 9.6037 6.51829 9.2767 7.29798L8.7235 7.06483C9.1111 6.14212 9.7753 5.42642 10.5451 5.10192C11.9716 4.5013 13.4914 4.80747 14.6113 5.92008C14.9323 6.24187 15.1981 6.55525 15.4051 6.96087C15.853 6.62916 16.4572 6.53001 17.0272 6.7196C17.7568 6.96237 18.2182 7.59604 18.2926 8.43853C19.3144 8.69633 20.4001 9.51328 20.4001 11.0874Z"
          fill="white"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_10640_68220"
          x1="0"
          y1="2400"
          x2="2400"
          y2="0"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B0084D" />
          <stop offset="1" stopColor="#FF4F8B" />
        </linearGradient>
        <clipPath id="clip0_10640_68220">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
